module.exports = __webpack_public_path__ + "img/Social Media.0381c673.png";